// extracted by mini-css-extract-plugin
export var acitonButtons = "_hb-0";
export var additionalIcon = "_hb-f";
export var block = "_hb-1";
export var blockContent = "_hb-7";
export var blockDescription = "_hb-8";
export var blockIcon = "_hb-9";
export var blockTitle = "_hb-6";
export var border = "_hb-a";
export var center = "_hb-l";
export var edge = "_hb-b";
export var edgeLabel = "_hb-c";
export var edgePath = "_hb-d";
export var error = "_hb-e";
export var flowchart = "_hb-g";
export var flowchartContent = "_hb-h";
export var highlighted = "_hb-3";
export var hover = "_hb-4";
export var icon = "_hb-i";
export var left = "_hb-m";
export var navButton = "_hb-j";
export var navButtons = "_hb-k";
export var right = "_hb-n";
export var selected = "_hb-2";
export var small = "_hb-5";